<div class="topMenu">
    <div class="container golf-wrap">
        @if(!showMenu){
            @if(backBtn.show){
                <button class="menu-back-btn" 
                        [routerLink]="backBtn.action ? null : backBtn.url"
                        (click)="backBtn.action ? setButtonAction(backBtn.action) : null">
                    <img src="assets/images/back.svg" alt="">
                    @if (backBtn.text){
                        <span>{{backBtn.text}}</span>
                    }
                </button>
            } @else {
                <button class="menu-btn" (click)="showMenu = true">
                    <img src="assets/images/menu-btn.svg" alt="">
                </button>
            }
        } @else {
            <div class="menu-close" (click)="showMenu = false"></div>
        }
        
        <div class="menu-wrap" [class.active]="showMenu">
            <div class="menu-head">
                <a (click)="showMenu = false" routerLink="/">
                    <img src="assets/images/home.svg" alt="Golf AI">
                </a>
                <!-- @if(showMenu){
                <button (click)="showMenu = false">
                    <img src="assets/images/closeWhite.svg" alt="">
                </button>
                } -->
            </div>
            <ul class="menu-list">
                <li>
                    <a (click)="setQuestion('Let’s book a tee time')">
                        <img src="assets/images/tee-time-icon.svg" alt="">
                        <span>{{'Book a tee time' | translate}}</span>
                        <img src="assets/images/right-arrow-white.svg" alt="">
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="/article">
                        <img src="assets/images/today-golf-icon.svg" alt="">
                        <span>{{'Today in golf' | translate}}</span>
                        <img src="assets/images/right-arrow-white.svg" alt="">
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="/play-golf">
                        <img src="assets/images/play-golf-white.svg" alt="">
                        <span>{{'Play golf' | translate}}</span>
                        <img src="assets/images/right-arrow-white.svg" alt="">
                    </a>
                </li>
                <li>
                    <a (click)="setQuestion('Golf Rules Questions')">
                        <img src="assets/images/rule-icon.svg" alt="">
                        <span>{{'Golf rules' | translate}}</span>
                        <img src="assets/images/right-arrow-white.svg" alt="">
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="/discover/pgatour">
                        <img src="assets/images/pga-tour.svg" alt="">
                        <img src="assets/images/right-arrow-white.svg" alt="">
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="/discover/liv">
                        <img src="assets/images/liv-golf-menu.svg" alt="">
                        <img src="assets/images/right-arrow-white.svg" alt="">
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="/discover/owgr">
                        <img src="assets/images/owgr-menu-btn.svg" alt="">
                        <img src="assets/images/right-arrow-white.svg" alt="">
                    </a>
                </li>
            </ul>
            @if (!isSignedIn) {
            <button class="sign-up-btn btn-white" routerLink="login">
                SIGN UP or LOGIN
            </button>
            } @else {
            <button class="sign-up-btn" (click)="logOut()">
                LOGOUT
            </button>
            }
        </div>
        <div class="logoBg">
            <a routerLink="/">
                <img class="top-logo mr-2" src="assets/images/logo.svg" alt="Golf AI">
            </a>
        </div>
        <!-- <div class="mainLogo d-none d-md-block">
            <img src="assets/images/logo.svg" alt="Golf AI">
        </div> -->
        <!-- menuBlock -->
        <!-- menuBlock -->
        <div class="d-inline-flex right-menu">
            @if (isSignedIn){
            <div class="profileBg">
                <a routerLink="settings/user-settings" class="profile" [class.noImage]="!user.imageUrl">
                    @if (user.imageUrl){
                    <img [src]="user.imageUrl" alt="">
                    } @else {
                    <div class="profile-letter">
                        {{user.name.substring(0, 2).toUpperCase()}}
                    </div>
                    }
                </a>
            </div>
            } @else if (url !== '/login' && url !== '/signup') {
            <a routerLink="login" class="smlBtn">Login or sign up</a>
            }
        </div>
    </div>
</div>